var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{attrs:{"id":"particles-js"}}),_c('p',{ref:"typewriter",staticClass:"is-family-monospace animated-typewriter line-1"},[_vm._v("Our heads are in the cloud. Computing.")])])}
var staticRenderFns = []

export { render, staticRenderFns }